import { Component, Inject } from '@angular/core';
import { BaseComponent } from '../../../base.component';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Folder } from '../../../../models/ui/folder.model';

@Component({
    selector: 'lex-add-edit-folder-dialog',
    templateUrl: './add-edit-folder-dialog.component.html',
    styleUrls: ['./add-edit-folder-dialog.component.scss'],
    standalone: false
})
export class AddEditFolderDialogComponent extends BaseComponent {
	public newFolderForm: UntypedFormGroup;
	public isEditing = false;
	private readonly folder: Folder;

	constructor(
		private formBuilder: UntypedFormBuilder,
		private dialogRef: MatDialogRef<AddEditFolderDialogComponent>,
		@Inject(MAT_DIALOG_DATA) private data: { folder: Folder }) {
		super();
		this.isEditing = !!data?.folder?.folderId;
		this.folder = data?.folder || new Folder();
		this.newFolderForm = this.formBuilder.group({
			folderName: [this.folder.folderName, [Validators.required, Validators.maxLength(256)]]
		});
	}

	public save(): void {
		this.folder.folderName = this.newFolderForm.controls['folderName'].value;
		this.dialogRef.close(this.folder);
	}
}
